import imgQuestionsToAsk from '../../../static/images/carousel-questions-to-ask-a-financial-advisor.jpg'
import imgAdvisorCost from '../../../static/images/carousel-financial-advisor-cost.jpg'
import imgSmallAccounts from '../../../static/images/carousel-small-accounts.jpg'
import imgDoINeed from '../../../static/images/carousel-do-i-need-a-financial-advisor.jpg'
import avatarBeccaStanek from '../../../static/images/author-becca-stanek.png'
import avatarJeffWhite from '../../../static/images/author-jeff-white.png'
import avatarBenGeier from '../../../static/images/author-ben-geier.jpg'
import avatarSusannahSnider from '../../../static/images/author-susannah-snider.jpg'

export interface Article {
  url: string
  imageUrl: string
  category: string
  title: string
  authorName: string
  authorAvatarUrl: string
  date: string
}

/**
 * Article list for the carousel. Titles and URLs come from the story; the
 * category, author, date, and image were taken from each article on
 * smartasset.com and hardcoded. The date is a point-in-time snapshot of the
 * article's "updated on" date and will not auto-update. Author avatars mirror
 * the small byline avatar next to each name; where an author has no photo it is
 * Gravatar's default silhouette (Ben Geier, Susannah Snider). For the cost
 * article, which has no author byline, the first editor is used.
 */
export const ARTICLE_CAROUSEL_ARTICLES: Article[] = [
  {
    url: 'https://smartasset.com/financial-advisor/questions-to-ask-a-financial-advisor',
    title: '12 Questions to Ask a Financial Advisor',
    imageUrl: imgQuestionsToAsk,
    category: 'Advisor Basics',
    authorName: 'Becca Stanek',
    authorAvatarUrl: avatarBeccaStanek,
    date: 'December 24, 2025'
  },
  {
    url: 'https://smartasset.com/financial-advisor/financial-advisor-cost',
    title: 'How Much Does a Financial Advisor Cost?',
    imageUrl: imgAdvisorCost,
    category: 'Advisor Fees & Costs',
    authorName: 'Jeff White, CEPF®',
    authorAvatarUrl: avatarJeffWhite,
    date: 'May 13, 2026'
  },
  {
    url: 'https://smartasset.com/financial-advisor/ask-an-advisor-financial-advisor-small-accounts',
    title: 'Do I Have Enough Money to Work With a Financial Advisor?',
    imageUrl: imgSmallAccounts,
    category: 'Advisor Basics',
    authorName: 'Susannah Snider, CFP®',
    authorAvatarUrl: avatarSusannahSnider,
    date: 'December 1, 2022'
  },
  {
    url: 'https://smartasset.com/financial-advisor/do-i-need-a-financial-advisor',
    title: 'Do I Need a Financial Advisor?',
    imageUrl: imgDoINeed,
    category: 'Advisor Basics',
    authorName: 'Ben Geier, CEPF®',
    authorAvatarUrl: avatarBenGeier,
    date: 'June 9, 2026'
  }
]
